<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      size="full-middle"
      :confirm-loading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      <span>打印标签</span>
    </template>
    <template #content>
      <gj-alert show-icon>
        <template #title>
          如果您的标签规格一致、打印数量与实际申报量一致，可以尝试快速填表功能。
        </template>
      </gj-alert>
      <el-form
          ref="form"
          :model="form"
          :inline="true"
          label-width="90px"
          >
        <div class="print-tip_group">
          <div class="print-tip">快速填表：</div>
          <el-form-item
              label="纸张类型"
              prop="paperType"
              label-width="80px">
            <gj-select
                v-model="form.paperType"
                :options="paperLabelOption"
                width="180px"
                :clearable="false"
            ></gj-select>
          </el-form-item>
          <el-form-item
              style="margin-left: 20px;">
            <gj-checkbox
                v-model="form.autoPrintNum"
                @input="autoPrintNumInput"
            >打印量等于申报量</gj-checkbox>
          </el-form-item>
        </div>
        <div>
          <el-form-item
              label="打印Made in China字样"
              prop="madeInChina"
              label-width="235px">
            <el-radio-group v-model="form.madeInChina">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
              style="margin-left: 17px;">
            <gj-checkbox
                v-model="form.skuOrName"
                style="margin-right: 10px;"
            ></gj-checkbox>
            <gj-select
                v-model="form.skuOrNameType"
                :options="skuOrNameTypeOption"
                width="130px"
                :clearable="false"
            ></gj-select>
          </el-form-item>
          <el-form-item
              style="margin-left: 19px;">
            <gj-checkbox
                v-model="form.isCustomContent"
                style="margin-right: 10px;"
            ></gj-checkbox>
            自定义内容
          </el-form-item>
        </div>
        <div style="margin:0 0 10PX 95px;">
          <gj-input
            v-model="form.customContent"
            show-word-limit
            :disabled="!form.isCustomContent"
            placeholder="请输入自定义内容"
            width="100%"
            maxlength="50">
          </gj-input>
        </div>
        <gj-table
            :index="false"
            name="printProductLabel"
            :data="form.items"
            :columns="columns"
            :loading="loading"
            :offsetHeight="58"
            :show-pagination="false">
          <template v-slot:header:paperType>
            <div class="paper-type">纸张类型</div>
          </template>
          <template v-slot:header:quantityShipped>
            <span class="gj-mr10">申报量</span>
          </template>
          <template v-slot:paperType="{ index }">
            <el-form-item
                :prop="`items.${index}.paperType`"
                :rules="[
                  { required: true, message: '请纸张类型', trigger: ['blur', 'change'] }
                ]"
                class="gj-table-item paper-type">
              <el-form-item
                  prop="paperType">
                <gj-select
                    v-model="form.items[index].paperType"
                    :options="paperLabelOption"
                    :clearable="false"
                    width="350px"
                ></gj-select>
              </el-form-item>
            </el-form-item>
          </template>
          <template v-slot:printNum="{ index }">
            <el-form-item
                :prop="`items.${index}.printNum`"
                :rules="[
                  $gjReRule(RE.pt0, '请输入正整数')
                ]"
                class="gj-table-item">
              <gj-input
                  v-model.number="form.items[index].printNum"
                  v-number.int
                  maxlength="5"
                  width="120px">
              </gj-input>
            </el-form-item>
          </template>
          <template v-slot:msku="{ row }">
            <div>
              <gj-tooltip :content="row.msku" :text-line="1">
                {{row.msku | defaultShow}}
              </gj-tooltip>
            </div>
            <div>
              <gj-tooltip :content="row.fnsku" :text-line="1">
                {{row.fnsku | defaultShow}}
              </gj-tooltip>
            </div>
          </template>
          <template v-slot:quantityShipped="{ row }">
            <span class="gj-mr10">{{row.quantityShipped | defaultShow}}</span>
          </template>
          <template v-slot:op="{ index }">
            <gj-button type="text" @click="deleteItem(index)">删除</gj-button>
          </template>
        </gj-table>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>

  import {formRuleMixin, modalMixIn} from "../../../../../minxins";
  import {getListingLabelsInfo,getDeliveryListingLabelsInfo} from "../../../../../api/logistics";
  import {isMeaningful, isMeaningless} from "../../../../../utils/common";
  import {getListingLabels} from "../../../../../api/product";
  export default {
    name: "app-print-label-modal",
    mixins: [modalMixIn, formRuleMixin],
    props: {
      ids: {
        type: Array,
        required: true
      },
      deliveryPlan:{
         required:false,
         default:()=>{
           return [];
         }
      }
    },
    data() {
      return {
        form: {
          paperType: 1,
          skuOrName: false,
          isCustomContent: false,
          autoPrintNum: false,
          englishTitle: true,
          madeInChina: true,
          customContent: "",
          skuOrNameType: 'productName',
          items: []
        },
        paperLabelOption: [
          {id: 1, text: "热敏纸（50*30）单排"},
          {id: 2, text: "热敏纸（100*30）双排"},
          {id: 3, text: "每张US信纸最多30个标签（1英寸x2-5/8英寸）"},
          {id: 4, text: "每页纸最多21个标签（A4纸，63.5毫米x38.1毫米）"},
          {id: 5, text: "每页纸最多24个标签（A4纸，63.5毫米x33.9毫米）"},
          {id: 6, text: "每页纸最多24个标签（A4纸，64.6毫米x33.8毫米）"},
          {id: 7, text: "每页纸最多24个标签（A4纸，66毫米x33.9毫米）"},
          {id: 8, text: "每页纸最多24个标签（A4纸，66毫米x35毫米）"},
          {id: 9, text: "每页纸最多24个标签（A4纸，70毫米x36毫米）"},
          {id: 10, text: "每页纸最多24个标签（A4纸，70毫米x37毫米）"},
          {id: 11, text: "每页纸最多27个标签（A4纸，63.5毫米x29.6毫米）"},
          {id: 12, text: "每页纸最多40个标签（A4纸，52.5毫米x29.7毫米）"},
          {id: 13, text: "每页纸最多44个标签（A4纸，48.5毫米x25.4毫米）"},
        ],
        columns: [
          {id: 'shipmentId', header: 'ShipmentID', field: 'shipmentId', width: '130px'},
          {id: 'picture', header: '图片', field: 'picture:listingImageUrl', width: '60px'},
          {id: 'msku', header: 'MSKU/FNSKU', field: 'slot:msku', minWidth: '120px'},
          {id: 'listingTitle', header: '条码内容', field: 'listingTitle', overflowLine: 2, minWidth: '200px'},
          {id: 'quantityShipped', header: 'slot:quantityShipped', field: 'slot:quantityShipped', width: '100px', align: 'right'},
          {id: 'printNum', header: '打印数量', field: 'slot:printNum', width: '150px'},
        ],
        loading: false,
        skuOrNameTypeOption: [
          {id: 'productName', text: '打印产品名称'},
          {id: 'sku', text: '打印SKU'},
        ],
      }
    },
    created() {
      this.updateLocalStorage('get')

      if(this.deliveryPlan.length === 0){
        this.loading = true;
        getListingLabelsInfo({
          ids: this.ids.join(',')
        })
            .then((data) => {
              if (data) {
                this.form.items = data.map(item => ({
                  shipmentId: item.shipmentId,
                  listingImageUrl: item.listingImageUrl,
                  msku: item.msku,
                  fnsku: item.fnsku,
                  listingTitle: item.listingTitle,
                  quantityShipped: item.quantityShipped,
                  printNum: null,
                  sku: item.sku,
                  productName: item.productName
                }));
              }
            })
            .complete(() => this.loading = false);
      }else{
          this.getDeliveryPlan();
          this.columns.forEach(item=>{
              if(item.id === "shipmentId") item.header='单据号';
              if(item.id === "quantityShipped") item.header='单据量';
         })
      }

    },
    methods: {
      getDeliveryPlan(){
        this.loading = true;
        getDeliveryListingLabelsInfo({idList:this.deliveryPlan.map(item => item.id)}).then(res=>{
           if(res && res.length){
             this.form.items = res.map(item => ({
               shipmentId: item.code,
               listingImageUrl: item.listingImageUrl,
               msku: item.msku,
               fnsku: item.fnsku,
               listingTitle: item.listingTitle,
               quantityShipped: item.quantityTransfer,
               printNum: null,
               sku: item.sku,
               productName: item.productName
             }));
           }
        }).complete(() => this.loading = false);
      },
      autoPrintNumInput(check) {
        if (check) {
          this.form.items.forEach(e => e.printNum = e.quantityShipped);
        } else {
          this.form.items.forEach(e => e.printNum = null);
          this.$refs.form.resetFields();
        }
      },
      deleteItem(index) {
        this.form.items.splice(index, 1);
      },
      updateLocalStorage(type){
        let form = {
          paperType: Number(this.form.paperType),
          madeInChina: this.form.madeInChina,
          skuOrName: this.form.skuOrName,
          skuOrNameType: this.form.skuOrNameType,
        }
        if(type === 'get'){
         let formData = window.localStorage.getItem("printModal");
         if(isMeaningful(formData)){
           this.form = Object.assign(this.form,JSON.parse(formData))
           // console.log(this.form)
         }
        }else{
          let strForm = JSON.stringify(form);
          window.localStorage.setItem("printModal",strForm)
        }
      },
      confirm() {
        if (isMeaningless(this.form.items) || this.form.items.length === 0) {
          this.$gjMessage.error('产品不能为空');
          return;
        }
        if (this.form.items.every(item => isMeaningless(item.printNum) || Number(item.printNum) === 0)) {
          this.$gjMessage.error('打印数量不能全为空或为0');
          return;
        }
        if (this.$gjFormValidate()) {
          this.updateLocalStorage('set')
          this.confirmLoading = true;
          getListingLabels({
            printType: this.form.paperType,
            isMadeInChina: this.form.madeInChina,
            labelsItems: this.form.items
              .filter(item => isMeaningful(item.printNum) && Number(item.printNum) > 0)
              .map(item => {
                let sku = null;
                if (this.form.skuOrName) {
                  sku = this.form.skuOrNameType === 'productName' ? item.productName : item.sku;
                }
                return {
                  sku,
                  fnsku: item.fnsku,
                  quantity: item.printNum,
                  title: item.listingTitle,
                  shipmentId: item.shipmentId,
                  customContent: this.form.customContent,
                };
              })
          })
            .then((url) => {
              window.open(url);
              this.$gjDestroy();
            })
            .complete(() => this.confirmLoading = false);
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .print-tip {
    display: inline-block;
    margin-top: 7px;
    margin-left: 12px;
    font-size: 12px;
    color: #333;
  }
  .paper-type {
    padding-left: 100px;
  }
  /deep/ .el-form-item {
    // margin-bottom: 10px;
    .el-input__inner{
      color: #333;
    }
  }
  /deep/ .el-form-item__label{
    color: #666;
  }
  /deep/ .el-form-item__content{
    position: relative;
  }
  /deep/ .el-radio {
    margin-right: 16px;
  }
  /deep/ .el-dialog__body{
    padding: 16px 16px 0 16px;
  }
  /deep/ .el-dialog__footer{
    padding: 16px !important;
  }
  .print-tip_group{
    padding-top: 12px;
  }
  /deep/ .gj-table--default td.vxe-body--column{
    height: 56px !important;
  }

</style>


